
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLeaves } from "../redux/actions/leaveActions";

const Leaves = () => {
  const dispatch = useDispatch();
  const { leaves, loading, error } = useSelector((state) => state.leave);

  const [searchName, setSearchName] = useState("");
  const [searchPhone, setSearchPhone] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;

  useEffect(() => {
    dispatch(fetchLeaves());
  }, [dispatch]);

  const filteredLeaves = leaves.filter((leave) => {
    const matchesName = leave.employee_name?.toLowerCase().includes(searchName.toLowerCase());
    const matchesPhone = leave.employee_phone?.includes(searchPhone);
    const leaveStartDate = new Date(leave.start_date).setHours(0, 0, 0, 0);

    const fromDateValid = fromDate ? leaveStartDate >= new Date(fromDate).setHours(0, 0, 0, 0) : true;
    const toDateValid = toDate ? leaveStartDate <= new Date(toDate).setHours(0, 0, 0, 0) : true;

    return matchesName && matchesPhone && fromDateValid && toDateValid;
  });

  const totalPages = Math.ceil(filteredLeaves.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredLeaves.slice(indexOfFirstItem, indexOfLastItem);

  const handleResetDate = () => {
    setFromDate("");
    setToDate("");
    setCurrentPage(1);
  };

  return (
    <div className="w-full h-auto bg-gray-100 p-4">
      <h1 className="text-2xl font-bold mb-4">Leave Management</h1>

      {/* FILTERS */}
      <div className="flex flex-wrap gap-2 mb-4">
        <input
          type="text"
          placeholder="Search by name"
          value={searchName}
          onChange={(e) => { setSearchName(e.target.value); setCurrentPage(1); }}
          className="px-3 py-2 border border-gray-300 rounded-md"
        />
        <input
          type="text"
          placeholder="Search by phone"
          value={searchPhone}
          onChange={(e) => { setSearchPhone(e.target.value); setCurrentPage(1); }}
          className="px-3 py-2 border border-gray-300 rounded-md"
        />
        <input
          type="date"
          value={fromDate}
          onChange={(e) => { setFromDate(e.target.value); setCurrentPage(1); }}
          className="px-3 py-2 border border-gray-300 rounded-md"
        />
        <input
          type="date"
          value={toDate}
          onChange={(e) => { setToDate(e.target.value); setCurrentPage(1); }}
          className="px-3 py-2 border border-gray-300 rounded-md"
        />
        <button
          onClick={handleResetDate}
          className="px-3 py-2 bg-gray-200 rounded hover:bg-gray-300"
        >
          Reset Date
        </button>
      </div>

      {loading ? (
        <p>Loading leaves...</p>
      ) : error ? (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded">
          Error: {error}
        </div>
      ) : filteredLeaves.length > 0 ? (
        <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
          <table className="min-w-[1000px] w-full text-sm text-left">
            <thead className="bg-black text-white">
              <tr>
                <th className="px-4 py-3 font-medium">ID</th>
                <th className="px-4 py-3 font-medium">Employee</th>
                <th className="px-4 py-3 font-medium">Phone</th>
                <th className="px-4 py-3 font-medium">Start Date</th>
                <th className="px-4 py-3 font-medium">End Date</th>
                <th className="px-4 py-3 font-medium">Reason</th>
                {/* <th className="px-4 py-3 font-medium">Status</th>  */}
                <th className="px-4 py-3 font-medium">Applied At</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {currentItems.map((leave) => (
                <tr key={leave.id} className="hover:bg-gray-50">
                  <td className="px-4 py-2 whitespace-nowrap">{leave.id}</td>
                  <td className="px-4 py-2 whitespace-nowrap">{leave.employee_name}</td>
                  <td className="px-4 py-2 whitespace-nowrap">{leave.employee_phone}</td>
                  <td className="px-4 py-2 whitespace-nowrap">
                    {new Date(leave.start_date).toLocaleDateString()}
                  </td>
                  <td className="px-4 py-2 whitespace-nowrap">
                    {new Date(leave.end_date).toLocaleDateString()}
                  </td>
                  <td className="px-4 py-2 max-w-[200px] break-words">{leave.reason}</td>
                  {/* <td className="px-4 py-2 capitalize whitespace-nowrap">{leave.status}</td> */}
                  <td className="px-4 py-2 whitespace-nowrap">
                    {new Date(leave.applied_at).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="flex justify-between items-center p-4 border-t">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300 disabled:opacity-50"
            >
              Previous
            </button>
            <p className="text-sm">Page {currentPage} of {totalPages}</p>
            <button
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300 disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </div>
      ) : (
        <p>No leave records found.</p>
      )}
    </div>
  );
};

export default Leaves;
